import { InjectionToken } from '@angular/core';

export type RindTheme = 'light' | 'dark';

/**
 * Theme persistence config. Provide via {@link provideTheme}.
 */
export interface ThemeConfig {
  /** localStorage key for the persisted light/dark preference. */
  storageKey: string;
}

export const THEME_CONFIG = new InjectionToken<ThemeConfig>('THEME_CONFIG');
